import { forwardRef, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { FeeRecord } from "../admission-list";
import CommonSelect from "../../../../core/common/commonSelect";
import { paymentType } from "../../../../core/common/selectoption/selectoption";

interface StudentSidebarProps {
  admissionData?: {
    registrationNumber: string;
    firstName: string;
    gender: string;
    status: string;
    createdAt: string;
    dateOfBirth: string;
    fatherEmail: string;
    fatherPhoneNumber: string;
    _id: string;
    lastName: string;
    nationality: string;
    religion: string;
    motherTongue: string;
    studentPicture: string;
    temporaryGR: string;
    appliedClass: { name: string; _id: string; registrationType: string };
    fatherName: string;
    testGroup: {
      testDateTime?: string;
    } | null;
    feeRecord: any;
    section: any;
    noOfSiblings: string;
  };
}

const StudentSidebar = forwardRef<HTMLDivElement, StudentSidebarProps>(
  (
    {
      admissionData = {
        registrationNumber: "",
        firstName: "",
        gender: "",
        status: "",
        createdAt: "",
        dateOfBirth: "",
        fatherEmail: "",
        fatherPhoneNumber: "",
        _id: "",
        lastName: "",
        nationality: "",
        religion: "",
        motherTongue: "",
        studentPicture: "",
      },
    },
    ref
  ) => {
    const [editData, setEditData] = useState<FeeRecord>(
      admissionData?.feeRecord as FeeRecord
    );
    const [isEditing, _setIsEditing] = useState(false);

    return (
      <>
        <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
          <div className="stickybar pb-4">
            <div className="card border-white">
              <div className="card-header">
                <div className="d-flex align-items-center flex-wrap row-gap-3">
                  <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                    <ImageWithBasePath
                      fullSrc={admissionData.studentPicture}
                      src="assets/img/students/student-01.jpg"
                      className="img-fluid"
                      alt="img"
                    />
                  </div>
                  <div className="overflow-hidden">
                    <span
                      className={`badge badge-soft-${
                        admissionData.status === "accepted"
                          ? "success"
                          : admissionData.status === "admitted"
                          ? "success"
                          : "warning"
                      } d-inline-flex align-items-center mb-1`}
                    >
                      <i className="ti ti-circle-filled fs-5 me-1" />
                      {admissionData.status}
                    </span>
                    <h5 className="mb-1 text-truncate">
                      {`${admissionData.firstName} ${admissionData.lastName}`}
                    </h5>
                    <p className="text-primary">
                      {admissionData.registrationNumber}
                    </p>
                  </div>
                </div>
              </div>

              {/* Basic Information */}
              <div className="card-body">
                <h5 className="mb-3">Basic Information</h5>
                <dl className="row mb-0">
                  <dt className="col-6 fw-medium text-dark mb-3">
                    Temporary GR
                  </dt>
                  <dd className="col-6 mb-3">
                    {admissionData.temporaryGR || "N/A"}
                  </dd>
                  <dt className="col-6 fw-medium text-dark mb-3">Gender</dt>
                  <dd className="col-6 mb-3">{admissionData.gender}</dd>
                  <dt className="col-6 fw-medium text-dark mb-3">
                    Date Of Birth
                  </dt>
                  <dd className="col-6 mb-3">
                    {new Date(admissionData.dateOfBirth).toLocaleDateString()}
                  </dd>
                  <dt className="col-6 fw-medium text-dark mb-3">
                    Nationality
                  </dt>
                  <dd className="col-6 mb-3">{admissionData.nationality}</dd>
                  <dt className="col-6 fw-medium text-dark mb-3">Religion</dt>
                  <dd className="col-6 mb-3">{admissionData.religion}</dd>
                  <dt className="col-6 fw-medium text-dark mb-3">
                    Mother Tongue
                  </dt>
                  <dd className="col-6 mb-3">{admissionData.motherTongue}</dd>
                </dl>
                {/* <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_fees_collect"
                  className="btn btn-primary btn-sm w-100"
                >
                  Fee voucher
                </Link> */}
              </div>
              {/* /Basic Information */}
            </div>

            {/* Primary Contact Info */}
            <div className="card border-white">
              <div className="card-body">
                <h5 className="mb-3">Primary Contact Info</h5>
                <div className="d-flex align-items-center mb-3">
                  <a
                    href={`tel:${admissionData.fatherPhoneNumber?.replace(
                      /[^\d+]/g,
                      ""
                    )}`}
                    className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default hover:bg-light-400"
                    title="Click to call"
                  >
                    <i className="ti ti-phone" />
                  </a>
                  <div>
                    <span className="text-dark fw-medium mb-1">
                      Phone Number
                    </span>
                    <p>{admissionData.fatherPhoneNumber || "Not available"}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <a
                    href={`mailto:${admissionData.fatherEmail}`}
                    className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default hover:bg-light-400"
                    title="Send email"
                  >
                    <i className="ti ti-mail" />
                  </a>
                  <div>
                    <span className="text-dark fw-medium mb-1">
                      Email Address
                    </span>
                    <p className="break-all">
                      {admissionData.fatherEmail || "Not available"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* /Primary Contact Info */}

            {/* Sibling Information */}
            <div className="card border-white">
              <div className="card-body">
                <h5 className="mb-3">Sibling Information</h5>
                {admissionData.noOfSiblings ? (
                  <span>{admissionData.noOfSiblings}</span>
                ) : (
                  "N/A"
                )}
              </div>
            </div>
            {/* /Sibling Information */}
          </div>
        </div>

        {/* Fee modal */}
        <div className="modal fade" id="add_fees_collect">
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            ref={ref}
          >
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h4 className="modal-title">Fee Voucher</h4>
                  <span className="badge badge-sm bg-primary ms-2">
                    {admissionData?.feeRecord?.recordIdentifier}
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div id="modal-datepicker" className="modal-body">
                  {admissionData && (
                    <div className="bg-light-300 p-3 pb-0 rounded mb-4">
                      <div className="row align-items-center">
                        <div className="col-lg-3 col-md-6">
                          <div className="d-flex align-items-center mb-3">
                            <Link
                              to={all_routes.studentGrid}
                              className="avatar avatar-md me-2"
                            >
                              <ImageWithBasePath
                                src={"assets/img/students/student-01.jpg"}
                                fullSrc={admissionData.studentPicture}
                                alt="img"
                              />
                            </Link>
                            <Link
                              to={all_routes.studentGrid}
                              className="d-flex flex-column"
                            >
                              <span className="text-dark">
                                {admissionData.firstName}{" "}
                                {admissionData.lastName}
                              </span>
                              {admissionData.appliedClass?.name},{" "}
                              {admissionData.section?.name}
                            </Link>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <span className="fs-12 mb-1">
                              Total Outstanding
                            </span>
                            <p className="text-dark">
                              {(
                                Number(
                                  admissionData?.feeRecord?.feeType?.amount || 0
                                ) -
                                Number(admissionData?.feeRecord?.discount || 0)
                              ).toLocaleString()}
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <span className="fs-12 mb-1">Last Date</span>
                            <p className="text-dark">
                              {dayjs(admissionData.createdAt).format(
                                "DD MMM YYYY"
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <span
                              className={`badge ${
                                admissionData.status.toLowerCase() ===
                                "admitted"
                                  ? "badge-soft-success"
                                  : "badge-soft-danger"
                              }`}
                            >
                              <i className="ti ti-circle-filled me-2" />
                              {admissionData.status}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Fees Group</label>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            admissionData?.feeRecord?.feeType?.feeGroup?.name ||
                            ""
                          }
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Fees Type</label>
                        <input
                          type="text"
                          className="form-control"
                          value={admissionData?.feeRecord?.feeType?.name || ""}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Amount</label>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            admissionData?.feeRecord?.feeType?.amount || ""
                          }
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Discount</label>
                        <input
                          type="text"
                          className="form-control"
                          name="discount"
                          value={editData?.discount}
                          onChange={(e) => {
                            if (
                              Number(e.target.value) >
                              (editData.invoiceItems[0]?.amount || 0)
                            ) {
                              return;
                            }
                            setEditData((prev) => ({
                              ...prev,
                              discount: Number(e.target.value) || 0,
                            }));
                          }}
                          readOnly={!isEditing}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Total Amount</label>
                        <input
                          type="text"
                          className="form-control"
                          value={(
                            Number(editData?.invoiceItems?.[0]?.amount || 0) -
                            Number(editData?.discount || 0)
                          ).toString()}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Payment Type</label>
                        <CommonSelect
                          className="select"
                          options={paymentType}
                          value={paymentType.find(
                            (item) => item.value === editData?.paymentType
                          )}
                          onChange={(selectedOption) =>
                            setEditData((prev) => ({
                              ...prev,
                              paymentType: selectedOption.value,
                            }))
                          }
                          isDisabled={!isEditing}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="mb-0">
                        <label className="form-label">Notes</label>
                        <textarea
                          rows={4}
                          className="form-control"
                          placeholder="Add Notes"
                          name="notes"
                          value={editData?.notes}
                          onChange={(e) =>
                            setEditData((prev) => ({
                              ...prev,
                              [e.target.name]: e.target.value,
                            }))
                          }
                          readOnly={!isEditing}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default StudentSidebar;
